import React, { useCallback } from 'react';

function Checkbox({ name, value, checked, label, innerOnChange, ariaLabel }) {
    return (
        <div className="uk-grid uk-grid-small">
            <div className="uk-width-auto">
                <input className="uk-checkbox focus" type="checkbox" id={name} name={name} value={value} checked={checked} onChange={innerOnChange} aria-label={ariaLabel} />
            </div>
            <div className="uk-width-expand">
                <label for={name}>{label}</label>
            </div>
        </div>
    );
}

function CheckboxGroup({ label, name: groupName, options, checkedValues = [], onChange, className = 'uk-margin', error, ariaLabel }) {
    const innerOnChange = useCallback(
        ({ target: { value, checked } }) => {
            if (checked) {
                onChange({ name: groupName, values: [...checkedValues, value] });
            } else {
                onChange({ name: groupName, values: checkedValues.filter(checkedValue => checkedValue !== value) });
            }
        },
        [checkedValues, groupName, onChange]
    );

    return (
        <div className={className}>
            {label && <label className="uk-form-label">{label}</label>}
            <div className="uk-grid-small uk-child-width-1-1 uk-grid" data-uk-grid="">
                <div>
                    {options.map(option => (
                        <Checkbox
                            key={option.value}
                            label={option.label}
                            name={option.value}
                            value={option.value}
                            innerOnChange={innerOnChange}
                            checked={checkedValues.includes(option.value)}
                            ariaLabel={`${checkedValues.includes(option.value) ? "Nicht mehr nach": "Nach"} ${ariaLabel} "${option.value}" filtern`}
                        />
                    ))}
                </div>
                {error && (
                    <div>
                        <div className="uk-text-danger">{error}</div>
                    </div>
                )}
            </div>
        </div>
    );
}

export default CheckboxGroup;
